import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag_horizontal",
  "use": "drag_horizontal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"drag_horizontal\"><path d=\"M9 3v8.25H4.373l1.935-1.943L5.25 8.25 1.5 12l3.75 3.75 1.058-1.057-1.936-1.943H9V21h1.5V3zM18.75 8.25l-1.058 1.057 1.936 1.943H15V3h-1.5v18H15v-8.25h4.628l-1.936 1.943 1.058 1.057L22.5 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol